module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/160.d29d2620.png";